import React from 'react';

export const ProcessIndicator = props => (
  <div className={props.show ? "d-block text-center fa-3x": "d-none"}><i className="fas fa-spinner fa-pulse"></i></div>
);
